const React = require("react");

function ApplePaySecondIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 1000 658"
    },
    viewBox: "0 0 1000 658",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M905.39,658H94.61C42.36,658,0,615.64,0,563.39V94.61C0,42.36,42.36,0,94.61,0h810.78C957.64,0,1000,42.36,1000,94.61 v468.78C1000,615.64,957.64,658,905.39,658z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M242.27,245.09c-2.19-23.97,18.99-54.27,48.68-56.09C294.97,214.19,270.38,247.77,242.27,245.09z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.84,369.73c-2.64,9.23-6.81,18.46-12.31,28.35c-8.13,14.73-16.93,23.96-24.4,29.67 c-8.57,6.81-20,8.13-30.12,4.18c-2.42-0.88-5.06-1.98-7.91-3.3c-11.21-4.4-23.52-4.62-34.73-0.22 c-3.08,1.32-6.59,2.64-10.33,3.96c-11.21,4.62-23.96,2.2-32.97-6.15c-23.08-21.76-43.96-60.88-43.96-105.06 c0-54.95,41.11-71.65,59.57-71.65c10.11,0,20.66,3.74,28.36,7.47c7.47,3.52,16.05,3.52,23.74,0.22 c9.01-3.74,21.32-7.69,32.75-7.69c20.88,0,36.27,10.11,46.16,23.3c-15.61,9.67-25.94,27.03-25.94,46.81 C308.75,341.81,321.94,361.15,340.84,369.73z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M465.16,204.64c-29.87,0-84.16,0-84.16,0v230.03h33.41v-78.45h46.25 c34.05,0,76.77-19.91,76.77-75.15C537.43,225.84,495.03,204.64,465.16,204.64z M459.06,327.64c-12.15,0-33.08,0-44.65,0v-93.45 h36.62c27.62,0,52.36,10.92,52.36,46.24C503.38,315.76,476.4,327.64,459.06,327.64z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.4,263.95c-43.98,0-64.94,31.16-64.94,52.99h30.58c0-12.52,15.44-25.62,34.95-25.62 s33.78,13.1,33.78,28.24v15.72c-9.61,0.58-34.95,2.33-52.13,3.79c-21.55,2.04-54.17,13.1-54.17,48.33s30,50.96,55.04,50.96 c20.97,0,42.52-14.85,51.26-33.78c0,18.63,0,32.61,0,32.61l30.87-2.62V322.18C684.64,287.53,663.67,263.95,619.4,263.95z  M653.77,377.22c-17.18,50.37-73.39,39.02-73.39,9.61c0-29.99,45.43-25.91,73.39-28.53V377.22z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.38,267.05c0,0-33.25,110.13-42.75,139.63l-42.38-139.63h-34.58l59.39,170.97 c-1.85,11.64-8.15,32.39-30.13,32.39h-13.3v26.84h13.06c37,0,47.4-9.67,62.4-51.51c14.99-41.83,61.67-178.7,61.67-178.7h-33.38 V267.05z",
    style: {
      fill: "#FFFFFF"
    }
  }))));
}

module.exports = ApplePaySecondIcon;